var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _path2, _path3, _path4, _path5, _circle3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 512,
    viewBox: "0 0 429 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.697,
    cy: 201.697,
    r: 201.697,
    fill: "#3158F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_35552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 404,
    height: 404
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 201.697,
    cy: 201.697,
    r: 201.697,
    fill: "#3158F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_35552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.776 30.9734C259.995 27.8095 275.99 24.382 283.46 23.0637C314.66 30.9734 381.013 70.7855 396.833 166.756C369.149 166.756 382.331 194.44 379.695 208.941C373.472 243.167 356.845 220.366 350.693 204.986C348.056 185.212 334.346 168.075 321.691 173.348C309.035 178.621 287.415 171.151 278.187 166.756C270.717 164.999 257.886 163.856 266.323 173.348C274.76 182.839 287.415 186.97 292.688 187.849C313.341 191.804 315.099 203.668 287.415 211.578C224.482 229.559 217.546 165.438 218.865 154.892C219.919 146.455 199.969 138.194 189.862 135.118C171.406 123.253 183.271 112.707 189.862 110.07C196.999 107.215 213.591 114.025 218.865 104.797C223.083 97.4147 217.986 93.8114 214.91 92.9326C210.076 91.6143 196.19 92.9326 179.316 108.752C158.224 128.526 137.131 102.161 135.813 100.842C134.495 99.524 130.54 94.2509 123.948 95.5691C118.675 96.6238 112.084 96.0086 109.447 95.5691C102.856 94.2509 104.174 87.6595 108.129 83.7046C111.858 79.976 128.782 74.9161 137.131 73.1584C147.238 72.7189 170.352 67.8852 181.953 52.0659C193.554 36.2465 214.91 31.4128 224.138 30.9734C232.926 32.2917 251.558 34.1373 255.776 30.9734Z",
    fill: "#0E38DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.901 56.0207C90.4641 52.8568 89.2337 43.2773 89.6731 38.8831C114.279 19.1089 163.756 -14.6391 164.81 8.56261C166.128 37.5648 150.309 58.6573 135.813 49.4293C121.317 40.2013 116.034 49.4293 114.715 49.4293C113.397 49.4293 109.447 59.9756 98.901 56.0207Z",
    fill: "#0E38DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1219 96.8853C63.2986 95.8307 49.6786 111.386 44.8466 119.296C40.6281 121.405 40.4523 126.327 40.8917 128.524C43.001 133.797 47.9226 130.721 50.1197 128.524C51.438 125.448 57.7657 120.087 72.5305 123.251C87.2952 126.415 92.7441 119.296 93.623 115.341C95.3823 109.629 94.9452 97.94 79.1219 96.8853Z",
    fill: "#0E38DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.248 340.121C202.757 344.339 198.626 356.819 197.747 362.531C194.346 373.082 203.02 378.347 212.248 370.437C221.476 362.527 232.022 363.846 238.614 365.164C245.205 366.482 262.343 365.166 271.571 346.71C280.799 328.254 264.979 325.617 259.706 332.209C255.488 337.482 244.766 338.802 239.932 338.802C234.659 337.484 221.74 335.902 212.248 340.121Z",
    fill: "#9AADF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5531 92.2818C61.1707 94.391 49.6577 107.222 44.824 113.374C42.6269 116.449 39.0236 123.39 42.1874 126.554C45.3513 129.718 49.6577 125.236 51.4154 122.6C53.6125 120.403 60.6434 116.801 71.1896 119.963C81.7359 123.125 88.7667 118.646 90.9638 116.011C105.465 89.6428 77.781 89.6452 68.5531 92.2818Z",
    fill: "#0E38DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4154 238.608C11.3391 204.86 30.3227 169.179 44.824 155.557C59.3232 143.692 75.1464 155.557 100.194 137.101C120.232 122.336 136.666 131.827 142.379 138.419C145.894 141.934 158.198 148.965 179.291 148.965C205.656 148.965 204.338 172.694 206.974 191.15C209.611 209.606 208.293 204.333 225.43 228.062C242.568 251.791 259.706 242.563 271.57 246.518C283.435 250.473 282.117 266.292 271.57 279.475C261.024 292.658 234.658 295.294 214.884 308.477C195.11 321.66 192.473 338.798 185.882 353.299C179.291 367.8 176.654 370.436 163.471 373.073C150.288 375.709 138.424 349.344 138.424 322.978C138.424 296.613 122.605 275.52 105.467 268.929C88.3292 262.337 71.1896 253.109 51.4154 238.608Z",
    fill: "#0E38DC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.0005,
    y: 281.212,
    width: 364.606,
    height: 230.788,
    rx: 23.2727,
    fill: "#29315D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 190.061,
    y: 376.242,
    width: 55.877,
    height: 11.6364,
    rx: 5.81818,
    fill: "#404C91"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 190.061,
    y: 352.97,
    width: 182.303,
    height: 11.6364,
    rx: 5.81818,
    fill: "#404C91"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 190.061,
    y: 320,
    width: 55.877,
    height: 11.6364,
    rx: 5.81818,
    fill: "#404C91"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 190.061,
    y: 451.879,
    width: 95.0303,
    height: 11.6364,
    rx: 5.81818,
    fill: "#404C91"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 376.242,
    width: 100.848,
    height: 11.6364,
    rx: 5.81818,
    fill: "#404C91"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0913,
    y: 314.182,
    width: 77.5758,
    height: 77.5758,
    rx: 15.5152,
    fill: "#3158F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.5 366.79V359.564C129.5 357.346 131.296 355.549 133.514 355.549C135.732 355.549 137.528 357.346 137.528 359.564V366.79H146.36V353.002C146.36 352.151 146.021 351.334 145.419 350.732L134.649 339.962C134.021 339.334 133.005 339.334 132.379 339.962L121.609 350.732C121.007 351.334 120.668 352.151 120.668 353.002V366.79H129.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.8855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134.091,
    y: 259.879,
    width: 38.7879,
    height: 38.7879,
    rx: 9.69697,
    transform: "rotate(45 134.091 259.879)",
    fill: "#29315D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 343.273,
    y: 426.667,
    width: 58.1818,
    height: 58.1818,
    rx: 29.0909,
    fill: "#29315D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.362 473.217C362.719 473.217 354.901 465.4 354.901 455.756C354.901 446.112 362.719 438.294 372.362 438.294C382.006 438.294 389.824 446.112 389.824 455.756",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.896 449.935H388.623",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.898 461.576H372.363",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380.124 455.756C380.138 450.335 378.685 445.012 375.919 440.35C375.187 439.078 373.831 438.294 372.364 438.294C370.896 438.294 369.54 439.078 368.808 440.35C363.201 449.856 363.201 461.657 368.808 471.163C369.543 472.432 370.898 473.215 372.365 473.219",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.004,
    cy: 467.397,
    r: 7.76081,
    fill: "white",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M386.417 466.192L383.398 469.211L381.588 467.399",
    stroke: "#3158F2",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.f0589c6520558f4e4911c4a4b1350181.svg";
export { ForwardRef as ReactComponent };